
import Vue from "vue";
export default Vue.extend({
	props: {
		to: String,
		disabled: Boolean
	},
	computed: {
		computedTo():string {
			return this.to || this.$route.fullPath;
		}
	},
	methods: {
		onClick(event:any) {
			this.$emit("click", event);
		}
	}
});
